module.exports = __webpack_public_path__ + "static/media/sound.fc610991.gif";